import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { companyInfo } from '../data/mock';

const AccordionItem = ({ title, children, isOpen, onToggle }) => {
  const contentRef = useRef(null);

  return (
    <div className="border-b border-white last:border-b-0">
      <button
        className="flex justify-between items-center w-full py-6 text-white text-xl md:text-2xl font-spectral tracking-wide focus:outline-none"
        onClick={onToggle}
      >
        {title}
        <span className="text-2xl transform transition-transform duration-300">
          {isOpen ? '—' : '+'}
        </span>
      </button>
      <div
        ref={contentRef}
        style={{
          maxHeight: isOpen && contentRef.current ? `${contentRef.current.scrollHeight}px` : '0',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out'
        }}
      >
        <div className="pb-6 text-white/70 text-lg leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
};

const AboutPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [visibleSections, setVisibleSections] = useState({});
  const [openAccordion, setOpenAccordion] = useState('Brewing Frames');
  const sectionRefs = useRef({});

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true
            }));
          }
        });
      },
      { threshold: 0.2 }
    );

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const stats = [
    { number: '10+', label: 'YEARS OF EXPERIENCE' },
    { number: '500+', label: 'PROJECTS COMPLETED' },
    { number: '50+', label: 'BRAND PARTNERS' },
    { number: '25+', label: 'AWARDS WON' }
  ];

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      <main className="pt-32 pb-24">
       

        {/* Hero Section */}
        <section className="px-6 md:px-12 lg:px-24 mb-8">
          <div className="max-w-[1800px] mx-auto">
            <div
              className={`transition-all duration-1000 ${
                isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
              }`}
            >
              <h1
                className="text-white text-5xl md:text-7xl lg:text-8xl font-spectral tracking-wide mb-2"
                style={{ fontFamily: "'Spectral SC', serif" }}
              >
                ABOUT US
              </h1>
              <p className="text-white/70 text-xl md:text-2xl max-w-3xl font-spectral leading-relaxed">
                {/* {companyInfo.description} */}
              </p>
            </div>
          </div>
        </section>

         {/* ALL ABOUT US Accordion */}
        <section className="px-8 md:px-16 lg:px-32 py-8">
          <div className="max-w-4xl mx-auto font-spectral">
            <AccordionItem 
              title="Brewing Frames" 
              isOpen={openAccordion === 'Brewing Frames'}
              onToggle={() => setOpenAccordion(openAccordion === 'Brewing Frames' ? '' : 'Brewing Frames')}
            >
              <p className="mb-6 text-white/80 text-lg md:text-xl max-w-4xl leading-relaxed">
                Brewing Frames is a creative-led production house that believes great stories
                are carefully brewed—frame by frame. We specialize in crafting compelling
                visual content across advertising, branded films, and digital platforms.
                Backed by a passionate team of filmmakers, producers, and visual artists, we
                focus on blending strong storytelling with refined aesthetics and technical
                excellence.
              </p>
              <p className="text-white/80 text-lg md:text-xl max-w-4xl leading-relaxed">
                At Brewing Frames, every project is approached with intention, detail, and
                originality. By combining creative vision, industry experience, and evolving
                technology, we deliver impactful films that connect with audiences and leave
                a lasting impression. Our process is collaborative, our thinking is fresh,
                and our goal is simple—to create visuals that feel meaningful, immersive, and
                memorable.
              </p>
            </AccordionItem>

            <AccordionItem 
              title="Founders" 
              isOpen={openAccordion === 'Founders'}
              onToggle={() => setOpenAccordion(openAccordion === 'Founders' ? '' : 'Founders')}
            >
              <p className="text-white/80 text-lg md:text-xl max-w-4xl leading-relaxed">
Anamika Chaudhary and Tyag Dharmik             </p>
            </AccordionItem>
          </div>
        </section>

        <div className="border-b border-white/10 pb-24"></div>

        {/* Contact CTA */}
        <section
          id="contact"
          ref={(el) => (sectionRefs.current.contact = el)}
          className="px-6 md:px-12 lg:px-24 py-24 border-t border-white/10"
        >
          <div className="max-w-[1800px] mx-auto">
            <div
              className={`transition-all duration-1000 ${
                visibleSections.contact
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-8 opacity-0'
              }`}
            >
              <h2 className="text-white/60 text-xs tracking-[0.3em] mb-6">
                GET IN TOUCH
              </h2>
              <h3
                className="text-white text-3xl md:text-5xl lg:text-6xl font-spectral mb-8"
                style={{ fontFamily: "'Spectral SC', serif" }}
              >
                Ready to create something extraordinary?
              </h3>
              <a
                href="mailto:hello@brewingframes.com"
                className="inline-block border border-white text-white px-12 py-4 text-xs tracking-[0.3em] hover:bg-white hover:text-black transition-all duration-500"
              >
                CONTACT US
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutPage;
